export default __webpack_public_path__ + "static/media/5_service.2c10e444.svg";